import React from "react"
import styled from "styled-components"
import { graphql, StaticQuery } from "gatsby"
import Image from "gatsby-image"

import { mixin, color } from "@src/settings"

import Hero from "@components/common/hero"
import PageIntro from "@components/common/page-intro"
import ContactIntro from "@components/common/contact-intro"

import Quality_Hero__mds from "@img/svg/quality/hero__mds.svg"

import Column from "@components/quality/column"
import { PageCont, Title, Container } from "@components/quality/styles"

const QualityPage = ({ data }) => (
  <PageCont baseBgColor={color.paleGray}>
    <Hero
      img={data["Quality_hero_img"]}
      title={<Quality_Hero__mds />}
      subTitle="品質・環境への取り組み"
    />
    <PageIntro
      title={<>地球にも人にも快適な環境づくり</>}
      subtitle={
        <>
          当社では、地球にも人にも快適な環境づくりが企業の発展にといて最重要課題であることを認識し、また、その取り組みが高品質なサービス提供につながっていくと考え、ISO等の規格認証を取得しました。今後も、規格に沿った企業活動を展開し、より一層のサービス工場を目指していきます。
        </>
      }
    />
    <Container>
      <Title>ISO ACHIEVEMENTS</Title>

      <Column
        className="Column"
        img={data["Iso14001"]}
        title="Certificate ISO 14001"
        cap="ISO 14001は、環境マネジメントシステムに関する国際規格です。当社は同規格の認証を継続しています。"
        data={[
          { key: "適合規格", val: "ISO 14001:2015" },
          { key: "登録番号", val: "2250330" },
          { key: "登録事業者", val: "LSF Technology Kajang 工場" },
        ]}
        isIso
      />

      <Column
        className="Column"
        img={data["Iso9001"]}
        title="Certificate ISO 9001"
        cap="ISO 9001は、品質マネジメントシステムに関する国際規格です。当社は同規格の認証を継続しています。"
        data={[
          { key: "適合規格", val: "ISO 9001:2015" },
          { key: "登録番号", val: "16146-A" },
          { key: "登録事業者", val: "LSF Technology Kajang 工場" },
        ]}
        isIso
      />

      <Column
        className="Column"
        img={data["Iatf16146"]}
        title="Certificate IATF 16949"
        cap="IATF 16949は、自動車産業の品質マネジメントシステムに関する国際規格です。当社は同規格の認証を継続しています。"
        data={[
          { key: "適合規格", val: "IATF 16949:2016" },
          { key: "登録番号", val: "16146-T" },
          { key: "登録事業者", val: "LSF Technology Kajang 工場" },
        ]}
        isIso
      />
    </Container>

    <Container>
      <Title>Awards</Title>

      <Column
        className="Column"
        img={data["Tspa_2024"]}
        title="Toyota Best Improvement in Quality（2024）"
      />

      <Column
        className="Column"
        img={data["Eqv_2024"]}
        title="Perodua Excellence Quality Vendor（2024）"
      />

      <Column
        className="Column"
        img={data["Pbsp_2024"]}
        title="Proton Best Supplier Quality Score Card (SQSC) Performance（2024）"
      />

      <Column
        className="Column"
        img={data["Qa_2024"]}
        title="Akashi Kikai Supplier Quality Award（2024）"
      />

      <Column
        className="Column"
        img={data["Saa_2022"]}
        title="Perodua Special Appreciation Award（2022）"
      />

      <Column
        className="Column"
        img={data["Eccv_2022"]}
        title="Perodua Excellent Cost Competitiveness Vendor（2022）"
      />

      <Column
        className="Column"
        img={data["Bsa_2020"]}
        title="HICOM HBPO Best Supplier Award（2020）"
      />

      <Column
        className="Column"
        img={data["Produa_die_skill_contest"]}
        title="Perodua Die Skill Contest（2018）"
      />

      <Column
        className="Column"
        img={data["Perodua_best_overall"]}
        title="Perodua Best Overall QCD Vendor (2015)"
      />

      <Column
        className="Column"
        img={data["Sarc_2014"]}
        title="Daihatsu Regional Contribution Award(2014)"
      />

      <Column
        className="Column"
        img={data["Sspo"]}
        title="MALAYSIA PRODUCTIVITY CORPORATION (MPC) Sustainability Shared Prosperity Organisation"
      />
    </Container>
    <ContactIntro />
  </PageCont>
)

export const query = graphql`
  query qualityImgs {
    Quality_hero_img: file(
      relativePath: { eq: "quality/hero-img_200311.jpg" }
    ) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    Iso14001: file(relativePath: { eq: "quality/iso14001-2026.png" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    Iso9001: file(relativePath: { eq: "quality/iso9001-2024.png" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    Iatf16146: file(relativePath: { eq: "quality/iatf16949-2024.png" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    Daihatsu_regional_contribution_award: file(
      relativePath: { eq: "quality/daihatsu-regional-contribution-award.jpg" }
    ) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    Perodua_best_overall: file(
      relativePath: { eq: "quality/perodua-best-overall.jpg" }
    ) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    Produa_die_skill_contest: file(
      relativePath: { eq: "quality/produa-die-skill-contest.jpg" }
    ) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    Tspa_2024: file(
      relativePath: { eq: "quality/toyota_supplier_performance_award_2024.jpg" }
    ) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    Eqv_2024: file(
      relativePath: { eq: "quality/excellence_quality_vendor_2024.jpg" }
    ) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    Saa_2022: file(
      relativePath: { eq: "quality/special_appreciation_award_2022.jpg" }
    ) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    Eccv_2022: file(
      relativePath: {
        eq: "quality/excellent_cost_competitiveness_vendor_2022.jpg"
      }
    ) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    Pbsp_2024: file(
      relativePath: { eq: "quality/proton_best_sqsc_performance_2024.jpg" }
    ) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    Sspo: file(
      relativePath: {
        eq: "quality/sustainability_shared_prosperity_organisation.jpg"
      }
    ) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    Qa_2024: file(relativePath: { eq: "quality/quality_award_2024.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    Sarc_2014: file(
      relativePath: {
        eq: "quality/special_award_regional_contribution_2014.jpg"
      }
    ) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    Bsa_2020: file(
      relativePath: { eq: "quality/best_supplier_award_2020.jpg" }
    ) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

    Edsc_2018: file(
      relativePath: { eq: "quality/eco_die_skill_contest_2018.jpg" }
    ) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 950) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`

export default QualityPage
